import PropTypes from 'prop-types';
import { useVenuesStore } from '@/features/venues/store/useVenuesStore';
import styles from './VenueMarker.module.css';

/**
 * VenueMarker - Map marker for venue locations
 * 
 * Shows a pulsing location pin with optional bounce animation
 * when selected. Displays the venue's primary sport icon.
 */
export function VenueMarker({ venue, isSelected, onClick }) {
  const { getSportIcon } = useVenuesStore();
  
  const primarySport = venue.sports[0];
  const sportIcon = getSportIcon(primarySport);

  return (
    <button
      className={`${styles.marker} ${isSelected ? styles.selected : ''}`}
      onClick={onClick}
      aria-label={`${venue.name} - ${venue.distance} miles away`}
    >
      <div className={styles.pin}>
        <span className={styles.icon}>{sportIcon}</span>
      </div>
      <div className={styles.pulse} />
      {isSelected && <div className={styles.bounce} />}
    </button>
  );
}

VenueMarker.propTypes = {
  venue: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    sports: PropTypes.arrayOf(PropTypes.string).isRequired,
    distance: PropTypes.number.isRequired,
  }).isRequired,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
};

export default VenueMarker;
